"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var BackgroundComponent =
/** @class */
function (_super) {
  __extends(BackgroundComponent, _super);

  function BackgroundComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChangeDarken = function () {
      _this.props.onChange({
        darken: _this.state.darkenPreview
      });

      _this.setState({
        darkenPreview: undefined
      });
    };

    _this.handleChangeDarkenPreview = function (value) {
      _this.setState({
        darkenPreview: value
      });
    };

    _this.handleChangeLighten = function () {
      _this.props.onChange({
        lighten: _this.state.lightenPreview
      });

      _this.setState({
        lightenPreview: undefined
      });
    };

    _this.handleChangeLightenPreview = function (value) {
      _this.setState({
        lightenPreview: value
      });
    };

    _this.handleChangeHasPadding = function () {
      _this.props.onChange({
        hasPadding: _this.props.state.hasPadding === undefined ? !_this.props.defaultHasPadding : !_this.props.state.hasPadding
      });
    };

    _this.handleChangeBackgroundColorPreview = function (e) {
      return _this.setState({
        backgroundColorPreview: e
      });
    };

    _this.handleChangeGradientDegPreview = function (gradientDegPreview, gradientDegPreviewIndex) {
      return _this.setState({
        gradientDegPreview: gradientDegPreview,
        gradientDegPreviewIndex: gradientDegPreviewIndex
      });
    };

    _this.handleChangeGradientOpacityPreview = function (gradientOpacityPreview, gradientOpacityPreviewIndex) {
      return _this.setState({
        gradientOpacityPreview: gradientOpacityPreview,
        gradientOpacityPreviewIndex: gradientOpacityPreviewIndex
      });
    };

    _this.handleChangeGradientColorPreview = function (gradientColorPreview, gradientColorPreviewIndex, gradientColorPreviewColorIndex) {
      return _this.setState({
        gradientColorPreview: gradientColorPreview,
        gradientColorPreviewIndex: gradientColorPreviewIndex,
        gradientColorPreviewColorIndex: gradientColorPreviewColorIndex
      });
    };

    _this.handleImageLoaded = function (imagePreview) {
      return _this.setState({
        imagePreview: imagePreview
      });
    };

    _this.handleImageUploaded = function () {
      return _this.setState({
        imagePreview: undefined
      });
    };

    _this.handleChangeModeSwitch = function (mode, modeFlag) {
      return function () {
        modeFlag ^= mode;

        _this.props.onChange({
          modeFlag: modeFlag
        });
      };
    };

    _this.state = {};
    return _this;
  }

  BackgroundComponent.prototype.render = function () {
    var Controls = this.props.Controls;
    return React.createElement(Controls, __assign({}, this.props, {
      handleChangeDarken: this.handleChangeDarken,
      handleChangeDarkenPreview: this.handleChangeDarkenPreview,
      handleChangeLighten: this.handleChangeLighten,
      handleChangeLightenPreview: this.handleChangeLightenPreview,
      handleChangeHasPadding: this.handleChangeHasPadding,
      handleChangeModeSwitch: this.handleChangeModeSwitch,
      handleChangeBackgroundColorPreview: this.handleChangeBackgroundColorPreview,
      handleChangeGradientDegPreview: this.handleChangeGradientDegPreview,
      handleChangeGradientOpacityPreview: this.handleChangeGradientOpacityPreview,
      handleChangeGradientColorPreview: this.handleChangeGradientColorPreview,
      handleImageLoaded: this.handleImageLoaded,
      handleImageUploaded: this.handleImageUploaded
    }, this.state));
  };

  return BackgroundComponent;
}(React.Component);

exports.default = BackgroundComponent;